/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type SymptomDtoSymptomType = (typeof SymptomDtoSymptomType)[keyof typeof SymptomDtoSymptomType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SymptomDtoSymptomType = {
  COUGH: 'COUGH',
  PHLEGM: 'PHLEGM',
  LACK_OF_ENERGY: 'LACK_OF_ENERGY',
  HEMOPTYSIS: 'HEMOPTYSIS',
  WEIGHT_LOSS: 'WEIGHT_LOSS',
  LOSS_OF_APPETITE: 'LOSS_OF_APPETITE',
  NIGHT_SWEATS: 'NIGHT_SWEATS',
  FEVER: 'FEVER',
  CHEST_PAIN: 'CHEST_PAIN',
} as const;
